module.exports = __webpack_public_path__ + "static/media/pra-news-wall.20443df6.png";